<template>
  <div class="modal fade" id="approve_modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="#00BEA5" class="bi bi-info-circle mt-3" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
            </svg>
            <p class="my-4" style="font-size: 16px">{{ message }}</p>
          </div>
          <div class="d-flex justify-content-center align-items-center mb-3">
            <button @click="emitAction(data)" id="approve_button" class="btn btn-primary px-5 py-2 ml-2 font-weight-bold" style="font-size: 14px">بله</button>
            <button @click="hideModal()" class="btn btn-danger px-5 py-2 mr-2 font-weight-bold" style="font-size: 14px">خیر</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "Approve",
  props: {
    message: {
      required: true
    },
    data: {
      required: false,
      default: null
    }
  },
  methods: {
    hideModal() {
      $('#approve_modal').modal('hide');
    },
    emitAction(data) {
      this.$emit('emitAction', data)
    }
  }
}
</script>

</style>